 /* global ga */
 "use strict";

var Fluxxor = require('fluxxor');
var _ = require('underscore');

var convertro = require('../utils/tracking/convertro');
var adobe = require('../utils/tracking/adobe');
var adwords = require('../utils/tracking/adwords');
var bingGoal16 = require('../utils/tracking/bing16');
var facebook = require('../utils/tracking/facebook');
import optimizely from '../utils/tracking/optimizely';


var TrackingStore = Fluxxor.createStore({
  actions: {
    PUSH_ENQUIRY_EVENT: 'sendEnquiryEvent',
    PUSH_GENERIC_EVENT: 'sendGenericEvent',
    PUSH_FORM_SUBMIT: 'sendFormSubmit',
  },

  initialize: function () {
    this.setMaxListeners(0);
    this.state = [];
  },

  sendFormSubmit: function(label) {
    optimizely(label);
    this.sendGenericEvent({
      action: 'submitted',
      label: label
    });
  },

  sendGenericEvent: function(payload) {
    var event = {
      'hitType': 'event',                 // Required.
      'eventCategory': payload.category,  // Required.
      'eventAction': payload.action       // Required.
    };

    if (payload.label) {
      event.eventLabel = payload.label;
    }

    if (payload.value && payload.value % 1 === 0 && payload.value >= 0) {
      event.eventValue = payload.value;
    }

    if (payload.nonInteraction) {
      event.nonInteraction = 1;
    }

    ga('send', event);
  },

  sendEnquiryEvent: function(payload) {

    var ga = window.ga;
    var source = payload.source;
    var url = window.location.origin + window.location.pathname;
    ga('send', 'event', 'Enquiry', source, url);

    convertro(payload.eventType);
    adobe(payload.source);
    adwords(payload.source);
    bingGoal16('Enquiry', payload.source, url);
    facebook('6023373046219', '0.00','GBP');
    optimizely(payload.source);
  },

  getState: function () {
    return this.state;
  }
});

module.exports = TrackingStore;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/stores/tracking.js
 **/